import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  CardActions,
  ButtonGroup,
  Button,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronUp, ChevronDown } from "mdi-material-ui";

ZoneInput.propTypes = {
  id: PropTypes.number,
  value: PropTypes.number,
  onPlusClick: PropTypes.func,
  onMinusClick: PropTypes.func,
  name: PropTypes.string,
};

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: theme.spacing(1),
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: 0,
  },
  actionButtons: {
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(1),
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0.5),
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    color: theme.palette.text.secondary,
  },
  actionButtonIcon: {},
}));

function ZoneInput({ id, value, name, onStepClick }) {
  const classes = useStyles();

  const skeleton = (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Skeleton className={classes.title} />
        <Skeleton />
      </CardContent>
      <CardActions className={classes.actions}>
        <ButtonGroup orientation="vertical" variant="text">
          <Button className={classes.actionButtons} disabled>
            <ChevronUp className={classes.actionButtonIcon} fontSize="large" />
          </Button>
          <Button className={classes.actionButtons} disabled>
            <ChevronDown
              className={classes.actionButtonIcon}
              fontSize="large"
            />
          </Button>
        </ButtonGroup>
      </CardActions>
    </Card>
  );
  return !id ? (
    skeleton
  ) : (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Typography className={classes.title}>{name}</Typography>
        <Typography component="h5" variant="h5">
          {value}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <ButtonGroup orientation="vertical" variant="text">
          <Button className={classes.actionButtons}>
            <ChevronUp
              className={classes.actionButtonIcon}
              fontSize="large"
              onClick={() => onStepClick(1)}
            />
          </Button>
          <Button className={classes.actionButtons}>
            <ChevronDown
              className={classes.actionButtonIcon}
              fontSize="large"
              onClick={() => onStepClick(-1)}
            />
          </Button>
        </ButtonGroup>
      </CardActions>
    </Card>
  );
}

export default React.memo(ZoneInput);
